import React from "react";
import { Link } from "react-router-dom";

const LocationSidebar = ({ activePage }) => {
  const menuItems = [
    { title: "Brisbane House Cleaning", link: "/house-cleaning-brisbane/" },
    {
      title: "Brisbane Commercial Cleaning",
      link: "/commercial-cleaning-brisbane/",
    },
    { title: "Brisbane Deep Cleaning", link: "/deep-cleaning-brisbane/" },
    { title: "Brisbane Move In Cleaning", link: "/move-in-cleaning-brisbane/" },
    {
      title: "Brisbane Move Out Cleaning",
      link: "/move-out-cleaning-brisbane/",
    },
    { title: "Byron Bay House Cleaning", link: "/house-cleaning-byron-bay/" },
    { title: "Byron Bay Bond Cleaning", link: "/bond-cleaning-byron-bay/" },
    {
      title: "Tweed Heads House Cleaning",
      link: "/house-cleaning-tweed-heads/",
    },
    { title: "Tweed Heads Bond Cleaning", link: "/bond-cleaning-tweed-heads/" },
    {
      title: "Coffs Harbour House Cleaning",
      link: "/house-cleaning-coffs-harbour/",
    },
    {
      title: "Coffs Harbour Commercial Cleaning",
      link: "/commercial-cleaning-coffs-harbour/",
    },
  ];

  // Determine current location from activePage
  const currentLocation = activePage.toLowerCase();

  let filteredItems = menuItems;
  if (currentLocation.includes("brisbane")) {
    filteredItems = menuItems.filter((item) =>
      item.link.toLowerCase().includes("brisbane"),
    );
  } else if (currentLocation.includes("byron-bay")) {
    filteredItems = menuItems.filter((item) =>
      item.link.toLowerCase().includes("byron-bay"),
    );
  } else if (currentLocation.includes("tweed-heads")) {
    filteredItems = menuItems.filter((item) =>
      item.link.toLowerCase().includes("tweed-heads"),
    );
  } else if (currentLocation.includes("coffs-harbour")) {
    filteredItems = menuItems.filter((item) =>
      item.link.toLowerCase().includes("coffs-harbour"),
    );
  }

  return (
    <div className="widget sidebar-widget ext-sidebar-menu widget_nav_menu">
      <h4 className="widget-title">
        Our Services in{" "}
        {currentLocation.includes("brisbane")
          ? "Brisbane"
          : currentLocation.includes("byron-bay")
            ? "Byron Bay"
            : currentLocation.includes("tweed-heads")
              ? "Tweed Heads"
              : currentLocation.includes("coffs-harbour")
                ? "Coffs Harbour"
                : currentLocation.includes("gold-coast")
                  ? "Gold Coast"
                  : ""}
      </h4>

      <ul className="menu">
        {filteredItems.map((item, index) => (
          <li key={index} className={activePage === item.link ? "active" : ""}>
            <Link
              to={item.link}
              onClick={() => {
                window.scrollTo({
                  top: 0,
                  left: 0,
                  behavior: "auto",
                });
              }}
            >
              {item.title}
            </Link>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default LocationSidebar;
